import React from 'react'
import { connect } from 'react-redux'
import { CANNED_MESSAGES } from 'constants/sms'
import { LastLocation } from './LastLocation'
import { UserAccounts } from './UserAccounts/UserAccounts'
import { UserDetailsDialog } from './UserDetailsDialog'
import { Notes } from './connected/Notes'
import { RecentShipments } from './connected/RecentShipments'
import { SMS } from './connected/SMS'
import { UserDetails } from './connected/UserDetails'

const UserOverviewComponent = ({
  isDriver,
  isOwnerOperator,
  showUserAccounts,
  userProfileDetails,
}) => (
  <div className='row' data-test='user-overview-tab-content'>
    <div className='col-xs-12 col-md-4'>
      <div className='mb3'>
        <UserDetails />
      </div>
      {showUserAccounts && (
        <div className='mb3'>
          <UserAccounts parentUser={userProfileDetails} />
        </div>
      )}
      <Notes />
    </div>
    <div className='col-xs-12 col-md-4'>
      <RecentShipments />
    </div>
    <div className='col-xs-12 col-md-4'>
      {(isDriver || isOwnerOperator) && userProfileDetails && <LastLocation />}
      <SMS cannedMessages={CANNED_MESSAGES} />
    </div>
    <UserDetailsDialog />
  </div>
)

export const UserOverview = connect(
  ({ userProfile: { isDispatcher, isDriver, isOwnerOperator, userProfileDetails } }) => ({
    isDriver,
    isOwnerOperator,
    userProfileDetails,
    showUserAccounts: isDriver || isDispatcher || isOwnerOperator,
  })
)(UserOverviewComponent)
